<template>
<body>
  <div class="loginbox" style="margin-left:calc((100vw - 500px) / 2);margin-top: calc((100vh - 460px) / 2);background:rgba(255,255,255,0.9);width:500px;height:460px;border-radius: 10px;">
    <ul>
      <li>
        <el-image :src="logo_footer" />
      </li>
      <li>
        <h4 class="logintittle">服务大厅身份绑定</h4>
      </li>
      <li>
        <input
          name="userId"
          type="text"
          id="userName"
          class="loginuser"
          @keyup.enter="handleEnterKey"
          v-model="userName"
          placeholder="请输入学号/工号"
        />
      </li>
      <li>
        <input
          name="password"
          type="password"
          id="password"
          class="loginpwd"
          @keyup.enter="handleEnterKey"
          placeholder="请输入登录密码"
          @click="clearPassword"
          v-model="password"
        />
      </li>
      <li>
        <span id="tipMsg" :style="{ color: '#FF0000' }">{{ session.error }}</span>
        <span
          id="promptMsg"
          style="height: 20px;color: #FF0000;text-align: center;font-size: 14px;"
        >{{session.promptMsg}}</span>
      </li>
      <li>
        <input
          id="bindbtn"
          name
          style="background: green"
          type="button"
          @click="doLogin"
          class="loginbtn"
          value="绑定"
        />
      </li>
    </ul>
  </div>
</body>
</template>

<script>
// import $ from "@/static/js/jquery.min.js";
import logo_footer from "@/static/images/logo_footer.png";
import { bindOpenId } from "@/api/wxAndQywxLogin.js";
import {ipURL,baseURL} from '@/config/net.config'
export default {
  name: "register",
  data() {
    return {
      logo_footer: logo_footer,
      userName: "",
      password: "",
      wxOpenId: "",
      qywxOpenId:"",
      session: {
        error: "",
        promptMsg:"您是第一次使用扫码登录，需绑定身份信息后再使用",
      },

    };
  },
  mounted() {
    this.clearTip();
    this.resizeh();
    window.addEventListener("resize", this.handleResize);
    this.wxOpenId = this.$route.params.wxOpenId;
    this.qywxOpenId = this.$route.params.qywxOpenId;
    console.log("openid",this.wxOpenId,this.qywxOpenId)
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    clearPassword() {
      this.password = "";
    },
    async doLogin() {
      this.clearTip();
      if (this.isEmpty(this.userName) || this.isEmpty(this.password)) {
        this.session.promptMsg="";
        this.session.error="请输入账号密码！"
        return;
      }
      let searchData = {
        username: this.userName,
        password: this.password,
        wxOpenId: this.wxOpenId,
        qywxOpenId: this.qywxOpenId,
      };
      let xkUserDto = await bindOpenId(JSON.stringify(searchData));
      console.log("xkuserdto====", xkUserDto);
      if (this.isEmpty(xkUserDto)) {
        this.session.promptMsg="";
        this.session.error="请输入账号密码！"
        return;
      }
      if (
        !this.isEmpty(xkUserDto.data.userId) &&
        !this.isEmpty(xkUserDto.data.password)
      ) {
        window.location.href =
        ipURL+"/cas/login?service="+baseURL+"/index&userId=" +
          xkUserDto.data.userId +
          "&password=" +
          xkUserDto.data.password +
          "&type=1";
      } else {
        window.location.href =
        ipURL+"/cas/login?service="+baseURL+"/";
      }
    },
    clearTip() {
      this.session.error="";
    },
    // resizeh() {
    //   $("body").height($(window).height());
    //   $(".loginbox").css({
    //     position: "absolute",
    //     left: ($(window).width() - $(".loginbox").width()) / 2,
    //     top: ($(window).height() - $(".loginbox").height()) / 2
    //   });
    // },
    handleResize() {
      this.resizeh();
    },
    isEmpty(str) {
      if (str === undefined || str === "" || str === null) {
        return true;
      }
      return false;
    },
    handleEnterKey(event) {
      event.preventDefault();
      this.doLogin(); // 点击绑定按钮
    }
  }
};
</script>

<style scope>
/* @import url(~@/static/css/bootstrap.min.css);
@import url(~@/static/css/login.css);
@import url(~@/static/css/iconfont.css); */
/* body {
  background: url(~@/static/images/loginbg.jpg) center center no-repeat;
  height: 100%;
  width: 100%;
  background-size: 100%;
}
body {
  overflow: hidden;
}

.helpbox {
  position: absolute;
  height: 320px;
  top: 33%;
  width: 312px;
  right: -260px;
}

.floatbtn {
  width: 53px;
  background: #3db769;
  color: #fff;
  padding: 10px;
  font-weight: bold;
  font-size: 18px;
  text-align: center;
  border-radius: 10px 0 0 10px;
  cursor: pointer;
}

.helpcon {
  position: absolute;
  top: -100px;
  right: 0;
  width: 260px;
  border: 1px solid #eee;
  background: #fff;
  font-size: 15px;
  padding: 15px 10px;
  line-height: 28px;
  color: #000;
  display: none;
} */
/* login.css */
</style>